import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Pages/login';
import Dashboard from './Pages/dashboard';
import PageNotFound from './Pages/PageNotFound';
import ProtectedRouter from './Custome_Components/ProtectedRouter';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function App() {

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                closeOnClick={true}
                draggable={true}
                pauseOnHover={true}
                style={{ zIndex: 1500000, position: "absolute", width: '50%', maxWidth: '80%' }}
            />
            <HashRouter>
                <Routes>
                    <Route path='/' element={<Navigate to="/login" />} />
                    <Route path='/login' element={<Login />} />
                    <Route element={<ProtectedRouter />}>
                        <Route path='/dashboard' element={<Dashboard />} />
                    </Route>
                    <Route path='*' element={<PageNotFound />} />
                </Routes>
            </HashRouter>
        </div>
    )
}